export default "__VITE_ASSET__BMR347z0__"